import React, { useEffect, useState } from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Row, Col, Button, Card } from 'react-bootstrap';
import PageTitle from '../../../layouts/PageTitle';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import { connect, useDispatch } from 'react-redux';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { useLoader } from '../../../../context/LoaderCotext';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import { getAwardtypesByCategory } from '../../../../services/AwardtypeService';
import { getAwardceremony } from '../../../../services/AwardceremonyService';

import Swal from 'sweetalert2';

import { clearDatabase, retrieveData, storeData } from '../../../../services/indexedDBUtils';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import { createFormAction } from '../../../../store/actions/FormsActions';
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom';
import { getFormById } from '../../../../services/FormService';
import { getMTEByEmail } from '../../../../services/MTEService';
import { getUserJoiningDate } from '../../../../services/UsersServices';
import { awardhistoryByEmail, createAwardhistory } from '../../../../services/AwardhistoryService';

const validationSchema = Yup.object({
  employeeName: Yup.object().required('Employee Name is required'),
  employeeNumber: Yup.string().required('Employee Number is required'),
  dateOfHire: Yup.date().required('Date of Hire is required'),
  employees6Months: Yup.string().required('Required'),
  nominatorsName: Yup.object().required("Nominator's Name is required"),
  awardType: Yup.string().required('Award Type is required'),
  spotAwardType: Yup.string().required('Spot Award Type is required'),
  nominatorsComments: Yup.string().required('Comments are required'),
  certificateWording: Yup.string().required('Certificate Wording is required'),
  awardAmount: Yup.number().required('Award Amount is required').positive(),
});

const AwardFormEdit = ({ profile, employeeList }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const [submitterName, setSubmitterName] = useState('');
  const { showLoader, hideLoader } = useLoader();
  const [employeeDefault, setEmpListDefault] = useState([]);
  const [nominatorsDefault, setNominatorsDefault] = useState([]);
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const [awardTypeList, setAwardTypeList] = useState([]);
  const [selectedAward, setSelectedAward] = useState(null);

  const [awardTypeSpotList, setAwardTypeSpotList] = useState([]);
  const [awardCeremonyList, setAwardCeremonyList] = useState([]);
  const [awardhistory, setAwardhistory] = useState([]);
  const [isSubsequentAward, setIsSubsequentAward] = useState(false);

  const { id } = useParams(); // Get the ID from URL

  const [initialValues, setInitialValues] = useState({
    employeeName: '',
    employeeNumber: '',
    dateOfHire: moment().toDate(),
    employees6Months: '',
    nominatorsName: '',
    awardType: '',
    spotAwardType: 'NA',
    nominatorsComments: '',
    certificateWording: '',
    awardCeremony: 'NA',
    awardAmount: '',
    boxFolderId: '0',
    boxFolderName: 'Award-Forms',
    timestamp: moment().unix(),
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const authCode = searchParams.get('code');
    const apiCall = async () => {
      if (typeof authCode != 'undefined' && authCode != '' && authCode != null) {
        await getBoxAuthToken(authCode)
          .then(async (response) => {
            if (typeof response.data.key != 'undefined') {
              const expiryDate = new Date();
              expiryDate.setTime(expiryDate.getTime() + response.data.life * 1000);
              Cookies.set('boxToken', response.data.key, {
                expires: expiryDate,
                path: '/',
                secure: true,
              });
              setCookieValue(Cookies.get('boxToken'));
              setFolderAPISuccess(true);
            }
          })
          .catch(async (error) => {});
      } else {
        setFolderAPISuccess(true);
      }
    };
    if (typeof cookieValue == 'undefined' && hasPermission('box-folders', ['show']) == true) {
      apiCall();
    } else {
      setFolderAPISuccess(true);
    }
  }, [cookieValue]);

  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    if (typeof profile != 'undefined') {
      setSubmitterName(profile.firstName + ' ' + profile.lastName);
    }
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  useEffect(() => {
    if (id) {
      showLoader();
      getFormById(id)
        .then((formData) => {
          if (formData) {
            getUsersSearch(formData.dynamicFields.employeeName.split(' ')[0])
              .then((response) => {
                const options = response.data.map((employee) => ({
                  value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                  label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                  email: employee.email,
                  employeeNumber: employee.employeeNumber,
                }));
                setEmpListDefault(options);
              })
              .catch((error) => {
                console.error('Error fetching employee data 2', error);
              });

            getUsersSearch(formData.dynamicFields.nominatorsName.split(' ')[0])
              .then((response) => {
                const options = response.data.map((employee) => ({
                  value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                  label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                  email: employee.email,
                  employeeNumber: employee.employeeNumber,
                }));
                setNominatorsDefault(options);
              })
              .catch((error) => {
                console.error('Error fetching employee data 2', error);
              });
            // Updating initial values based on fetched form data
            console.log('tete ', formData.dynamicFields);
            setInitialValues({
              submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
              employeeName: {
                value: formData.dynamicFields.employeeName,
                label: formData.dynamicFields.employeeName,
              },
              employeeNumber: formData.dynamicFields.employeeNumber,
              dateOfHire: moment(formData.dynamicFields.dateOfHire).toDate(),
              employees6Months: formData.dynamicFields.employees6Months,
              nominatorsName: formData.dynamicFields.nominatorsName,
              awardType: formData.dynamicFields.awardType,
              spotAwardType: formData.dynamicFields.spotAwardType,
              nominatorsComments: formData.dynamicFields.nominatorsComments,
              certificateWording: formData.dynamicFields.certificateWording,
              awardCeremony: formData.dynamicFields.awardCeremony,
              awardAmount: formData.dynamicFields.awardAmount,
            });
          }
        })
        .finally(() => {
          hideLoader();
        });
    }
  }, [id]);

  useEffect(() => {
    const getAward = async () => {
      try {
        const data = await getAwardtypesByCategory('normal');
        setAwardTypeList(data);
      } catch (error) {
        console.error('Error fetching awardtype by category normal:', error);
      }
    };
    getAward();

    const getSpotAward = async () => {
      try {
        const data = await getAwardtypesByCategory('spot');
        setAwardTypeSpotList(data);
      } catch (error) {
        console.error('Error fetching awardtype by category spot:', error);
      }
    };
    getSpotAward();

    const getCeremony = async () => {
      try {
        const data = await getAwardceremony();
        setAwardCeremonyList(data);
      } catch (error) {
        console.error('Error fetching awardceremony:', error);
      }
    };
    getCeremony();
  }, []);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const calculateEmployees6Months = (dateOfHire) => {
    if (!dateOfHire) return '';
    const today = moment(); // Current date
    const dateOfJoining = moment(dateOfHire); // Parse the date of joining
    // Calculate the difference in months
    const monthsDifference = today.diff(dateOfJoining, 'months');
    // Set the value based on the condition
    const employees6Months = monthsDifference >= 6 ? 'Yes' : 'No';
    return employees6Months;
  };

  const handleEmployeeChange = async (selectedOption, setFieldValue) => {
    setFieldValue(`employeeName`, selectedOption);
    const folderIdRes = await getBoxFolderOfEmpByEmail(selectedOption.email);
    const dateOfJoiningRes = await getUserJoiningDate(selectedOption.email);
    if (typeof folderIdRes.isError != 'undefined' && folderIdRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Data Error',
        text: 'Employee data not configured with box, Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });

      setFieldValue(`email`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`boxFolderId`, '');
      setFieldValue(`employees6Months`, 'No');
      return false;
    }
    setFieldValue(`boxFolderId`, folderIdRes.folderId || '0');
    setFieldValue(`employeeNumber`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`email`, selectedOption.email);

    const getManager = await getMTEByEmail(selectedOption.email);
    if (
      typeof getManager != 'undefined' &&
      typeof getManager.contract != 'undefined' &&
      getManager.contract != '' &&
      getManager.contract.toLowerCase() != profile.contract.toLowerCase() &&
      profile.role.toLowerCase() !== 'admin'
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'You are not accosiated with selected employee contract, please select correct employee and contract',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`email`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`boxFolderId`, '');
      setFieldValue(`employees6Months`, 'No');
      return false;
    }

    if (typeof dateOfJoiningRes.isError != 'undefined' && dateOfJoiningRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Hire Date Error',
        text: 'Employee hire date not configured with portal, Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });

      setFieldValue(`email`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`boxFolderId`, '');
      setFieldValue(`employees6Months`, 'No');
      setFieldValue(`dateOfHire`, moment().toDate());
      return false;
    } else {
      setFieldValue(`dateOfHire`, moment(dateOfJoiningRes.dateOfJoining).toDate());
      setFieldValue(
        `employees6Months`,
        calculateEmployees6Months(moment(dateOfJoiningRes.dateOfJoining).toDate())
      );
    }

    const getAwardHistory = await awardhistoryByEmail(selectedOption.email);
    setAwardhistory(getAwardHistory || []);
  };

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'award-form',
      contractor: 'ssai',
      dynamicFields: [{ ...data }],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
          const awardhistory = await createAwardhistory({
            employeeName: data.employeeName,
            employeeNumber: data.employeeNumber,
            employeeEmail: data.email,
            dateOfJoining: data.dateOfHire,
            nominatorsName: data.nominatorsName,
            awardDate: moment().toDate(),
            awardType: selectedAward.value,
            spotBonus: data.spotAwardType,
            isApproved: true,
            awardAmount: data.awardAmount,
            isSubsequent: selectedAward.isSubsequent || false,
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });
      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    if (typeof data != 'undefined') {
      let payloadForms = {
        ...data,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
        employeeName: data.employeeName.value,
      };

      if (!selectedAward || selectedAward.showSpotBonus != true) {
        payloadForms = {
          ...payloadForms,
          spotAwardType: 'NA',
        };
      }

      handleUploadBatch(payloadForms);
    }
  };

  const handleChangeAwardType = async (selectedOption, setFieldValue) => {
    setSelectedAward(selectedOption);
    setFieldValue('awardType', selectedOption.label);

    const currentYear = moment().year();

    const filteredResults = awardhistory.filter((item) => {
      const awardYear = moment(item.awardDate).year();
      return (
        item.isSubsequent &&
        item.awardType.includes(selectedOption.value) &&
        awardYear === currentYear
      );
    });

    if (filteredResults.length > 0) {
      setFieldValue('awardAmount', selectedOption.subsequentAmount || '0');
    } else {
      setFieldValue('awardAmount', selectedOption.amount);
    }
  };

  return (
    <>
      <PageTitle pageTitle="Edit Nomination for Award Form" />
      <Card>
        <div
          className="d-flex justify-content-end"
          style={{
            fontSize: '14px',
            fontWeight: '600',
            paddingBottom: '10px',
          }}
        >
          <Link
            className="mb-2 text-primary"
            target="_blank"
            to="https://ssaihq.app.box.com/file/1765344326114"
          >
            Instruction to Submit the Award Nomination form
          </Link>
          <Link
            className="mb-2 text-primary"
            target="_blank"
            style={{ marginLeft: '40px' }}
            to="https://ssaihq.app.box.com/file/1979244412788"
          >
            Award Recognition Guidelines
          </Link>
        </div>
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <FormikForm>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="employeeName">Employee Name</label>
                    <AsyncSelect
                      name="employeeName"
                      loadOptions={loadOptions}
                      defaultOptions={employeeList}
                      placeholder="Select Employee Name"
                      isSearchable
                      onChange={(selectedOption) =>
                        handleEmployeeChange(selectedOption, setFieldValue)
                      }
                      value={values.employeeName}
                    />
                    <ErrorMessage name="employeeName" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="employeeNumber">Employee Number</label>
                    <Field
                      type="text"
                      name="employeeNumber"
                      className="form-control"
                      placeholder="Employee Number"
                      readOnly
                      value={values.employeeNumber}
                    />
                    <ErrorMessage name="employeeNumber" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="dateOfHire">Date of Hire</label>
                    <DatePicker
                      selected={values.dateOfHire}
                      onChange={(date) => {
                        setFieldValue('dateOfHire', date);
                        setFieldValue('employees6Months', calculateEmployees6Months(date));
                      }}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                      readOnly
                    />
                    <ErrorMessage name="dateOfHire" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="employees6Months">Employees 6 Months</label>
                    <Field
                      type="text"
                      name="employees6Months"
                      className="form-control"
                      placeholder="Employees 6 Months"
                      readOnly
                    />
                    <ErrorMessage name="employees6Months" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="nominatorsName">Nominator's Name</label>
                    <AsyncSelect
                      name="nominatorsName"
                      loadOptions={loadOptions}
                      defaultOptions={employeeList}
                      placeholder="Select Nominator's Name"
                      isSearchable
                      onChange={(selectedOption) =>
                        setFieldValue('nominatorsName', selectedOption.label)
                      }
                      value={nominatorsDefault.find((e) => e.value === values.nominatorsName)}
                    />
                    <ErrorMessage name="nominatorsName" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="awardType">Award Type</label>
                    <Select
                      name="awardType"
                      options={awardTypeList}
                      placeholder="Award Type"
                      isSearchable
                      onChange={(selectedOption) => {
                        handleChangeAwardType(selectedOption, setFieldValue);
                      }}
                    />
                    <ErrorMessage name="awardType" component="div" className="text-danger" />
                  </div>
                </Col>

                {selectedAward && selectedAward.showSpotBonus == true && (
                  <Col>
                    <div className="form-group">
                      <label htmlFor="spotAwardType">Spot Award Type</label>
                      <Select
                        name="spotAwardType"
                        options={awardTypeSpotList}
                        placeholder="Spot Award Type"
                        isSearchable
                        onChange={(selectedOption) => {
                          setFieldValue('spotAwardType', selectedOption.label);
                          setFieldValue('awardAmount', selectedOption.amount);
                        }}
                      />
                      <ErrorMessage name="spotAwardType" component="div" className="text-danger" />
                    </div>
                  </Col>
                )}
              </Row>
              <Row className="mt-4">
                <Col>
                  <div className="form-group">
                    <label htmlFor="nominatorsComments">Nominator's Comments</label>
                    <Field
                      as="textarea"
                      name="nominatorsComments"
                      className="form-control"
                      placeholder="Enter nominator's comments"
                    />
                    <ErrorMessage
                      name="nominatorsComments"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="certificateWording">Certificate Wording</label>
                    <Field
                      as="textarea"
                      name="certificateWording"
                      className="form-control"
                      placeholder="Enter certificate wording"
                    />
                    <ErrorMessage
                      name="certificateWording"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="awardCeremony">Award Ceremony</label>
                    <Select
                      name="awardCeremony"
                      options={awardCeremonyList}
                      placeholder="Award Ceremony"
                      isSearchable
                      onChange={(selectedOption) =>
                        setFieldValue('awardCeremony', selectedOption.label)
                      }
                    />
                    <ErrorMessage name="awardCeremony" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex mt-4 mb-3">
                  <div className="form-group">
                    <label htmlFor="awardAmount">Award Amount ($)</label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Field
                        type="number"
                        name="awardAmount"
                        className="form-control"
                        placeholder="Award Amount"
                        min="0"
                        step="0.01"
                      />
                    </div>
                    <ErrorMessage name="awardAmount" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <Button variant="primary" type="submit">
                  Re-submit
                </Button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(AwardFormEdit);
